import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

// Title/subtitle widths — literal strings so Tailwind's scanner keeps the classes; varied so
// the list reads like real content rather than a uniform grid.
const ROW_WIDTHS = [
  { key: 0, title: 'w-2/5', sub: 'w-1/4' },
  { key: 1, title: 'w-1/3', sub: 'w-1/5' },
  { key: 2, title: 'w-1/2', sub: 'w-1/4' },
  { key: 3, title: 'w-2/5', sub: 'w-1/3' },
  { key: 4, title: 'w-1/3', sub: 'w-1/5' },
  { key: 5, title: 'w-1/2', sub: 'w-1/4' },
]

function ListRowSkeleton(props: { title: string; sub: string; collapsed?: boolean }) {
  return (
    <div
      className={cn(
        'flex items-center rounded-lg [transition-property:padding,gap] duration-250 ease-in-out',
        props.collapsed ? 'gap-0 p-0' : 'gap-2 px-2.5 py-2',
      )}
    >
      <Skeleton className="size-8 shrink-0 rounded-md" />
      <div
        className={cn(
          'flex min-w-0 flex-1 flex-col overflow-hidden [transition-property:opacity,max-height] ease-in-out',
          props.collapsed ? 'max-h-0 opacity-0 [transition-duration:100ms,250ms]' : 'max-h-16 opacity-100 duration-250',
        )}
      >
        <div className="flex h-5 items-center">
          <Skeleton className={`h-3.5 ${props.title}`} />
        </div>
        <div className="flex h-4 items-center">
          <Skeleton className={`h-3 ${props.sub}`} />
        </div>
      </div>
    </div>
  )
}

export function ListSkeleton(props: { rows?: number; collapsed?: boolean }) {
  const rows = props.rows ?? 6
  return (
    <>
      <div
        className={cn(
          'grid [transition-property:grid-template-rows,opacity] duration-250 ease-in-out',
          props.collapsed ? 'grid-rows-[0fr] opacity-0' : 'grid-rows-[1fr] opacity-100',
        )}
      >
        <div className="min-h-0 overflow-hidden px-2 py-1.25">
          <Skeleton className="h-2.5 w-14" />
        </div>
      </div>
      {ROW_WIDTHS.slice(0, rows).map((w) => (
        <ListRowSkeleton key={w.key} title={w.title} sub={w.sub} collapsed={props.collapsed} />
      ))}
    </>
  )
}
